import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';

const TimeIntervalDropDown = ({ onSelect, dataRetentionDays }) => {
  TimeIntervalDropDown.propTypes = {
    onSelect: PropTypes.func,
    dataRetentionDays: PropTypes.number.isRequired,
  };

  const fullTimeIntervals = [
    { label: 'Last 5 minutes', value: 5 },
    { label: 'Last 15 minutes', value: 15 },
    { label: 'Last 30 minutes', value: 30 },
    { label: 'Last 1 hour', value: 60 },
    { label: 'Last 3 hours', value: 180 },
    { label: 'Last 6 hours', value: 360 },
    { label: 'Last 12 hours', value: 720 },
    { label: 'Last 24 hours', value: 1440 },
    { label: 'Last 3 days', value: 4320 },
    { label: 'Last 7 days', value: 10080 },
    { label: 'Last 15 days', value: 21600 },
    { label: 'Last 30 days', value: 43200 },
  ];

  // Filter intervals by retention period
  const maxMinutes = dataRetentionDays * 1440;
  const timeIntervals = fullTimeIntervals.filter((t) => t.value <= maxMinutes);

  const [selectedInterval, setSelectedInterval] = useState(timeIntervals[0]?.value || '');

  useEffect(() => {
    if (selectedInterval && !timeIntervals.some(t => t.value === selectedInterval)) {
      setSelectedInterval(timeIntervals[0]?.value || '');
      onSelect(timeIntervals[0]?.value || null);
    }
  }, [dataRetentionDays]);

  const handleSelectChange = (event) => {
    const selectedValue = parseInt(event.target.value, 10);
    setSelectedInterval(selectedValue);
    onSelect(selectedValue);
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="time-interval-label">Time Interval</InputLabel>
      <Select
        labelId="time-interval-label"
        id="time-interval"
        value={selectedInterval}
        onChange={handleSelectChange}
        label="Time Interval"
      >
        {timeIntervals.map((interval) => (
          <MenuItem key={interval.value} value={interval.value}>
            {interval.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TimeIntervalDropDown;
